import { ListProps, TextField, SelectField } from 'react-admin';

import {
  BooleanField,
  ManyField,
  TextInput,
  Grid,
  GridList,
  Forbidden,
  MovePositionField,
  NullableBooleanInput, SelectArrayInput,
} from '@components';
import { useExporter, useRbacList } from '@hooks';
import { requirementsOptions } from '../requirements-options';
import cls from './QuestionList.module.css';
import { dealerTiersChoices } from '@types';

export const QuestionList = (props: ListProps) => {
  const exporter = useExporter({
    filename: 'Questions',
    props: {
      'id': {
        label: 'ID',
      },
      'nameMx': {
        label: 'Name MX',
      },
      'isVisible': {
        label: 'Is visible',
        transform: 'boolean',
      },
      'withCustomAnswer': {
        label: 'Custom',
        transform: 'boolean',
      },
      'isMultiple': {
        label: 'Multiple',
        transform: 'boolean',
      },
      'isTable': {
        label: 'Table',
        transform: 'boolean',
      },
      'isPlanner': {
        label: 'Planner',
        transform: 'boolean',
      },
      'isEnabled': {
        label: 'Enabled',
        transform: 'boolean',
      },
      'isOptional': {
        label: 'Optional',
        transform: 'boolean',
      },
      'isSendToCredit': {
        label: 'Send to Analysis',
        transform: 'boolean',
      },
      'answers': {
        label: 'Answers',
        transform: (answers) => {
          return answers.map(g => g.nameMx).filter(Boolean).join(';\r\n');
        },
      },
    },
  });

  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList
      {...props}
      exporter={exporter}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
      className={cls.list}
    >
      <Grid
        rowClick="edit"
        className={cls.grid}
        defaultColumns={'position requirements nameMx answers withCustomAnswer excludedTiers isVisible isMultiple isTable isEnabled isOptional'.split(' ')}
      >
        <MovePositionField source="position" label="Position" />
        <SelectField
          source="requirements"
          label="Applies to type of User"
          choices={requirementsOptions}
          sortable={false}
        />
        <TextField source="nameMx" label="Name MX" />
        <TextField source="nameEn" label="Name EN" />
        <ManyField source="answers" noload label="Answers" />
        <TextField source="excludedTiers" label="Excluded for Tier" sortable={false} />
        <BooleanField source="isVisible" label="Is visible" />
        <BooleanField source="withCustomAnswer" label="Custom" />
        <BooleanField source="isMultiple" label="Multiple" />
        <BooleanField source="isTable" label="Table" />
        <BooleanField source="isPlanner" label="Planner" />
        <BooleanField source="isEnabled" label="Enabled" />
        <BooleanField source="isOptional" label="Optional" />
        <BooleanField source="isSendToCredit" label="Send to Analysis" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" name="q" key="q" variant="outlined" label="Search" alwaysOn />,
  <NullableBooleanInput
    style={{ width: 100 }}
    source="isEnabled"
    key="isEnabled"
    label="Is enabled"
    trueLabel="Yes"
    falseLabel="No"
  />,
  <NullableBooleanInput
    style={{ width: 100 }}
    source="isVisible"
    key="isVisible"
    label="Is visible"
    trueLabel="Yes"
    falseLabel="No"
  />,
  <SelectArrayInput
    style={{ width: 100 }}
    key="excludedTiers"
    source="excludedTiers"
    label="Excluded for Tier"
    choices={dealerTiersChoices}
    className={'MS-field'}
  />,
];
